import React from "react";
import CommonContainer from "../CommonContainer";
import { X } from "lucide-react";
import { useRouter } from "next-nprogress-bar";
import useStatusChallenge from "@/hooks/client/useStatusChallenge";

const DesktopContainer: React.FC = () => {
  const { statusChallengeEligible, statusChallengeComplete } =
    useStatusChallenge();
  const router = useRouter();
  const onBack = () => {
    router.back();
  };
  return (
    <div className="mx-auto flex min-h-[95vh] w-full items-center">
      <div className="bg-global-gondola-challenge-mobile flex h-[95vh] w-1/2 flex-col items-center justify-evenly px-6 py-6">
        <img
          src="/assets/gondola-challenge/challenge.png"
          alt="5%"
          className="h-fit"
        />
        <span className="text-center text-xl text-[#B1B1B1]">
          <div className="mb-4 w-full border border-white/10" />
          The average traveler on Gondola earns{" "}
          <span className="text-primary">16%</span> of their hotel rate back in
          points
        </span>
      </div>
      <div className="relative flex h-[95vh] w-1/2 flex-col items-center justify-evenly gap-5 bg-[#0f1925]">
        {statusChallengeEligible && !statusChallengeComplete && (
          <div className="absolute right-5 top-5">
            <X
              className="h-5 w-5 cursor-pointer text-primary"
              onClick={onBack}
            />
          </div>
        )}
        <CommonContainer />
      </div>
    </div>
  );
};

export default DesktopContainer;
